export const dateEvent = [
  {
    date: '14 January, 2021',
    event: 'Makar Sankranti (Snan)'
  },
  {
    date: '11 February , 2021',
    event: 'Mauni Amavasya (Snan)'
  },
  {
    date: '16 February, 2021',
    event: 'Basant Panchami (Snan)'
  },
  {
    date: '27 February, 2021',
    event: 'Magh Poornima'
  },
  {
    date: '11 March , 2021',
    event: 'Maha Shivratri (Shahi Snan)'
  },
  {
    date: '28 March, 2021',
    event: 'Falgun Purnima (Shahi Snan)'
  },
  {
    date: '12 April, 2021',
    event: 'Somvati Amavasya (Shahi Snan)'
  },
  {
    date: '14 April , 2021',
    event: 'Baisakhi (Shahi Snan)'
  },
  {
    date: '21 April , 2021',
    event: 'Ram Navami (Snan)'
  },
  {
    date: '27 April , 2021',
    event: 'Chaitra Purnima (Shahi Snan)'
  }
];

export const kumbhMelaLocations = [
  'Haridwar on the Ganges in Uttarakhand.',
  'Ujjain on the Shipra in Madhya Pradesh.',
  'Nashik on the Godavari in Maharashtra.',
  'Prayagraj at the confluence of the Ganges, the Yamuna, and the mythical Sarasvati in Uttar Pradesh.'
];

export const kumbhMelaInfo = [
  {
    title: 'About Kumbh Mela: Embracing Spirituality and Festivities',
    html: `<p class="darkGreyText">The Kumbh Mela is a renowned Hindu pilgrimage and is considered the world's largest public gathering. Held every three years, it rotates across four cities—Prayagraj (Allahabad), Haridwar, Ujjain, and Nashik. The grandest of all is the Maha Kumbh Mela, which happens once every 12 years. The next Maha Kumbh Mela is scheduled from 13 January 2025 to 26 February 2025, taking place at the sacred confluence of the Ganga, Yamuna, and Saraswati rivers in Prayagraj (Allahabad). The festival attracts millions of devotees and spiritual seekers from all over the world, who gather to take holy dips in the river and participate in various religious activities. The 2025 Maha Kumbh Mela is expected to accommodate pilgrims in a dedicated tent city and offers special train services to Prayagraj for an easier travel experience.</p>`
  },
  {
    title: 'Maha Kumbh Mela 2025: Important Bathing Dates',
    html: `<table class="" style="width: 100%; text-align: center; border: 1px solid lightgrey; background-color: rgb(250, 250, 248);"> <thead> <tr> <th class="blackText" style="border: 1px solid lightgrey; width: 50%;">Event</th> <th class="blackText" style="border: 1px solid lightgrey; width: 50%;">Date and Time</th> </tr> </thead> <tbody style="width: 100%;"> <tr> <td style="border: 1px solid lightgrey; width: 50%;">Maha Kumbh Mela 2025 Starts</td> <td style="border: 1px solid lightgrey; width: 50%;">January 13, 2025</td> </tr> <tr> <td style="border: 1px solid lightgrey; width: 50%;" >Maha Kumbh Mela 2025 Ends</td> <td style="border: 1px solid lightgrey; width: 50%;" >February 26, 2025</td> </tr> <tr> <td style="border: 1px solid lightgrey; width: 50%;" >Paush Purnima</td> <td style="border: 1px solid lightgrey; width: 50%;" >January 13, 2025</td> </tr> <tr> <td style="border: 1px solid lightgrey; width: 50%;" >Makar Sankranti (First Shahi Snan)</td> <td style="border: 1px solid lightgrey; width: 50%;" >January 14, 2025</td> </tr> <tr> <td style="border: 1px solid lightgrey; width: 50%;" >Mauni Amavasya (Second Shahi Snan)</td> <td style="border: 1px solid lightgrey; width: 50%;" >January 29, 2025</td> </tr> <tr> <td style="border: 1px solid lightgrey; width: 50%;" >Basant Panchami (Third Shahi Snan)</td> <td style="border: 1px solid lightgrey; width: 50%;" >February 3, 2025</td> </tr> <tr> <td style="border: 1px solid lightgrey; width: 50%;" >Maghi Purnima</td> <td style="border: 1px solid lightgrey; width: 50%;" >February 12, 2025</td> </tr> <tr> <td style="border: 1px solid lightgrey; width: 50%;" >Maha Shivratri</td> <td style="border: 1px solid lightgrey; width: 50%;" >February 26, 2025</td> </tr> </tbody> </table>`
  },
  {
    title: 'How to Go to Kumbh Mela by Train',
    html: `<p class="darkGreyText">Indian Railways has introduced special trains to facilitate travel to Prayagraj for the Maha Kumbh Mela in 2025. These trains operate from various cities across India, ensuring smooth access to the pilgrimage site. You can check the special train timetable for Kumbh Mela on the official IRCTC platform or MakeMyTrip's website and book tickets online. To find a suitable train, simply visit the "Kumbh Mela Special Trains" section on MakeMyTrip's homepage, which displays train schedules, timings, and available seats.</p>`
  },
  {
    title: 'Special Train for Allahabad Kumbh Mela: Facilities and Services',
    html: `<p class="darkGreyText">The special trains for the 2025 Maha Kumbh Mela will be equipped with several facilities to ensure a comfortable journey for passengers. Key features include:</p><ul>
  <li>Over 900 special trains operating from various cities to Prayagraj and back.</li>
  <li>A 40% increase in the number of special trains to accommodate the festive rush.</li>
  <li>Upgraded infrastructure and amenities to improve passenger experience.</li>
  <li>Circular trains operating on routes such as Prayagraj-Varanasi-Ayodhya-Prayagraj.</li>
  <li>Mobile UTS (Unreserved Ticketing System) to facilitate easy booking of tickets.</li>
  <li>Over 500 ticketing kiosks installed at railway stations in Prayagraj.</li>
</ul>
<p class="darkGreyText">These trains offer various coach types, including Sleeper Class, 3rd AC, 2nd AC, 1st AC, and General Seating. Additionally, there are coaches for disabled passengers and special luggage coaches.</p>
`
  },
  {
    title: 'Kumbh Mela Special Train TimeTable',
    html: `<p class="darkGreyText appendBottom5">The special train timetable for Kumbh Mela spans the entire 45-day festival and beyond. To find the right train for your journey to Prayagraj, visit IRCTC's platform or MakeMyTrip, where you can view available trains, timings, and routes. Some trains run daily, while others may operate on specific days of the week. You can select trains based on your travel preferences, whether it’s weekdays or weekends.</p>
<p class="darkGreyText appendBottom5">Major cities from where you can board special trains to Prayagraj include:</p>
<ul class="paddingL20 darkGreyText" style="list-style-type: disc">
  <li class="appendBottom5">Varanasi</li>
  <li class="appendBottom5">Rishikesh</li>
  <li class="appendBottom5">Howrah</li>
  <li class="appendBottom5">Mumbai</li>
  <li class="appendBottom5">New Delhi</li>
  <li class="appendBottom5">Dehradun</li>
  <li class="appendBottom5">Lucknow</li>
  <li class="appendBottom5">Gorakhpur</li>
  <li class="appendBottom5">Ahmedabad</li>
  <li class="appendBottom5">Patna</li>
</ul>
<p class="darkGreyText">Choose your source city, check the train schedule, and book your tickets accordingly.</p>

`
  },
  {
    title: 'Book Kumbh Mela Special Train Online',
    html: `<p class="darkGreyText appendBottom5">You can easily book tickets for the special train services to Prayagraj via the IRCTC platform or MakeMyTrip. Here's how:</p>
<ol class="appendBottom5">
  <li>Visit the "Trains" section on the MakeMyTrip website or app.</li>
  <li>Enter your source city, destination, and date of journey to search for available trains.</li>
  <li>Choose the train that suits your schedule and check ticket availability.</li>
  <li>Enter your details and complete the payment process.</li>
  <li>Receive your e-ticket on your phone and email, along with the PNR number.</li>
</ol>
<p class="darkGreyText">If your ticket is waitlisted, keep checking the PNR status for updates on seat confirmation.</p>
`
  },
  {
    title: 'Check the PNR Status of Kumbh Mela Special Train',
    html: `
    <p class="darkGreyText appendBottom5">To check the status of your special train ticket, follow these steps:</p>
<ol class="appendBottom5">
  <li>Go to the "Trains" section on the MakeMyTrip website or app.</li>
  <li>Select "PNR Status Check."</li>
  <li>Enter your 10-digit PNR number and click "Check."</li>
  <li>View your ticket's confirmation or waitlist status.</li>
</ol>
    `
  }
];

export const RAILS_KUMBH_MELA_FAQS = {
  list: [
    {
      question: `Q. Can I book my special train for Allahabad Kumbh Mela in advance?`,
      answer: `Yes, you can book tickets for your preferred Allahabad/Prayagraj Kumbh Mela train at least 2 months in advance.`
    },
    {
      question: `Q. Are special trains available for Kumbh Mela from top cities like Kolkata, Bengaluru, Chennai and Mumbai?`,
      answer: `Yes, various special trains operate from top cities like Kolkata, Mumbai, Bengaluru and Chennai for the 2025 Prayagraj Maha Kumbh Mela and back.`
    },
    {
      question: `Q. Do special Kumbh Mela trains run on time?`,
      answer: `The Indian Railways has taken special initiatives to expand railways infrastructure and introduce new locomotives, among other initiatives, to ensure the timely operation of Kumbh Mela special trains. Before starting your journey, make sure to check the train schedule and live running status.`
    },
    {
      question: `Q. Can I get all the regular amenities on a Kumbh Mela special train?`,
      answer: `The introduction of Kumbh Mela special trains comes with necessary tweaks to make possible amenities available on board that ensure passenger comfort on the journey.`
    },
    {
      question: `Q. Do Prayagraj Kumbh Mela special trains run on all days?`,
      answer: `The Prayagraj Kumbh Mela special trains have been scheduled to operate on all days from different routes. Check the timetable for your train route before booking for better journey planning.`
    }
  ],
  title: 'Frequently Asked Questions'
};
